const PriceChart = () => {
  return <>Price chart - TODO</>;
};

export default PriceChart;
